const mentoringPrograms = [
  {
    id: 1,
    title: 'Mentoria Teológica',
    description: 'Acompanhamento personalizado no desenvolvimento teológico e ministerial com professores experientes.',
    icon: 'ri-graduation-cap-line',
    color: 'bg-blue-500'
  },
  {
    id: 2,
    title: 'Mentoria em Adoração',
    description: 'Desenvolvimento de habilidades em ministério de louvor e adoração com mentores especializados.',
    icon: 'ri-music-2-line',
    color: 'bg-purple-500'
  },
  {
    id: 3,
    title: 'Mentoria em Aconselhamento',
    description: 'Orientação prática para o ministério de aconselhamento pastoral e assistência espiritual.',
    icon: 'ri-user-heart-line',
    color: 'bg-green-500'
  },
  {
    id: 4,
    title: 'Mentoria em Pregação',
    description: 'Aperfeiçoamento em técnicas de pregação expositiva e comunicação eficaz da Palavra.',
    icon: 'ri-mic-line',
    color: 'bg-orange-500'
  }
];

export default function Mentoring() {
  return (
    <section id="mentorias" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Programas de Mentoria
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Acompanhamento personalizado e individualizado para seu desenvolvimento ministerial com mentores experientes
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {mentoringPrograms.map((program) => (
              <div
                key={program.id}
                className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-lg p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className={`w-16 h-16 ${program.color} rounded-lg flex items-center justify-center mb-6`}>
                  <i className={`${program.icon} text-white text-3xl`}></i>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {program.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {program.description}
                </p>

                <div className="flex items-center gap-4 text-sm text-gray-700">
                  <div className="flex items-center gap-2">
                    <i className="ri-user-line text-teal-600"></i>
                    <span>Individual</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-calendar-line text-teal-600"></i>
                    <span>Personalizado</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-lg p-12 text-center text-white">
            <h3 className="text-3xl font-bold mb-4">
              Pronto para Começar sua Jornada?
            </h3>
            <p className="text-xl mb-8 text-teal-50">
              Entre em contato conosco e descubra qual curso ou mentoria é ideal para você
            </p>
            <a
              href="https://wa.me/5567992870208"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-bold hover:bg-teal-50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Fale Conosco no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
